import { render, staticRenderFns } from "./DxBareRootsInfoForm.vue?vue&type=template&id=174c4e97&scoped=true&"
import script from "./DxBareRootsInfoForm.vue?vue&type=script&lang=js&"
export * from "./DxBareRootsInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./DxBareRootsInfoForm.vue?vue&type=style&index=0&id=174c4e97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c4e97",
  null
  
)

export default component.exports